import React, { useEffect, useMemo, useState } from "react"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import {
  faBellConcierge,
  faBolt,
  faCaretDown,
  faCaretRight,
  faChampagneGlasses,
  faClose,
  faCommentDollar,
  faMinus,
  faPlus,
  faTable,
  faTrash,
  faUser,
  faUserAlt,
  faUtensils,
  faLocationDot,
  faWarning,
  faPrint,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import GetSpace from "../../../utils/space"
import { useRegister } from "../../../hooks/Register/useRegister"
import { TitleChildrenPath, TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import {
  drinksMemory,
  extraServiceMemory,
  mealsMemory,
  comboMemory,
  customerMemory,
  tableMemory,
  addtionalMemory,
  companyMemory,
} from "../../../Objects/Memory/Memory"
import { useError } from "../../../context/useErrorContext"
import { CountElements } from "../../../components/CountElements/CountElements"
import { OrderEntity } from "../../../Objects/Order/OrderEntity"
import { OrderMeal } from "../../../Objects/Order/OrderMeal"
import { OrderDrink } from "../../../Objects/Order/OrderDrink"
import { MealEntity } from "../../../Objects/MealsAndDrinks/MealEntity"
import { ElementOrder } from "../../../components/ElementOrder/ElementOrder"
import { useEmployerLogged } from "../../../context/useEmployeeContext"
import { useConfirmation } from "../../../context/useConfirmationContext"
import { CustomerEntity } from "../../../Objects/Customer/CustomerEntity"
import { Tables } from "../../../Objects/Table/Tables"
import { CalculatePromotions } from "../../../Objects/Calculates/CalculatePromotions"
import { CalculateTotalOrder } from "../../../Objects/Calculates/CalculateTotalOrder"
import { DetailsPaymentPupop } from "./DetailsPaymentPupop"
import { OrderPaymentEntity } from "../../../Objects/Order/OrderPaymentEntity"
import { useSaveOrder } from "../../../hooks/Order/useSaveOrder"
import { useReloadMemory } from "../../../hooks/useReloadMemory"
import { convertToLocalMoney } from "../../../Objects/Generics/Helps"
import { EMoneyConditionType } from "../../../Enum/EMoneyConditionType"
import THEME from "../../../configuration/Theme"
import { SIZE } from "../../../configuration/Sizes"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { ECustomerPaymentType } from "../../../Enum/ECustomerPaymentType"
import { EOrderItemChargeType } from "../../../Enum/EOrderItemChargeType"
import { EOrderType } from "../../../Enum/EOrderType"
import { CalculateView } from "./Components/CalculateView"
import { BasicCard } from "../../../components/BasicCard/BasicCard"
import i18next from "i18next"
import { useTranslation } from "react-i18next"
import { usePermission } from "../../../hooks/Permissions/usePermission"
import { Permissions } from "../../../Enum/PermissionsType"
import { CanView } from "../../../components/CanView/CanView"
import { EOrderCurrentStatus } from "../../../Enum/EOrderCurrentStatus"
import { GenericDropDown } from "../../../components/Dropdown/Dropdown"
import { EOrderPlaceType } from "../../../Enum/EOrderPlaceType"
import { ExtraServiceEntity } from "../../../Objects/ExtraService/ExtraServiceEntity"
import { AwardEntity } from "../../../Objects/Awards/AwardEntity"
import { ListSelections, ListSelectionsProbs } from "../../../components/ListSelections/ListSelections"
import { ViewRegister } from "../../../components/ViewRegister/ViewRegister"
import { CostumerList } from "./Components/CustomerList"
import { CancelOrderPupop } from "./CancelOrderPupop"
import { usePlanUsage } from "../../../hooks/Company/usePlanUsage"
import { PlanUsageStatus } from "../../../Objects/Company/PlanUsageStatus"
import { useUpgradePlan } from "../../../context/useUpgradePlanContext"
import { PlanUsageAlert } from "../../../components/PlanUsageAlert/PlanUsageAlert"
import { getOrderFlowStatusBadges } from "../../../Objects/Order/orderStatusBadges"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { EOrderStatusType } from "../../../Enum/EOrderStatus"
import { ListItem } from "../../../components/List/List"
import { EAccountPlansType } from "../../../Enum/EAccountPlansType"
import { AlertTriangle } from "lucide-react"
import { OrderPrintOptionsPupop } from "../../../components/OrderPrintOptionsPupop/OrderPrintOptionsPupop"
import { SelectionEntity } from "../../../Objects/Selection/SelectionEntity"
import { GenericOrderFood } from "../../../Objects/Order/GenericOrderFood"
import { CustomerPopup } from "../Customer/CustomerPopup"
import { RodizioOrderPopup } from "./RodizioOrderPopup"
import { useRodizio } from "../../../hooks/Rodizio/useRodizio"
import { useGetTableOpenOrders } from "../../../hooks/Tables/useGetTableOpenOrders"
import type { RodizioManagement } from "../../../Objects/Rodizio/RodizioManagement"
import type { RodizioSession } from "../../../Objects/Rodizio/RodizioSession"

const renderProviderChargeReference = (externalReference: string | undefined, label: string) => {
  if (!externalReference) {
    return null
  }

  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-900">
      <span className="font-semibold">{label} </span>

      <span className="break-all font-mono">{externalReference}</span>
    </div>
  )
}

interface OrderPupopProbs {
  order?: OrderEntity

  title: string

  onClonse: () => void

  onSave: () => void | Promise<void>
}

export const OrderPupop: React.FC<OrderPupopProbs> = ({ order, title, onClonse, onSave }) => {
  const { t } = useTranslation("order")

  const titleRemove = t("label_remove")

  const messageRemove = t("message_confirm_remove")

  const titleCantAddService = t("title_already_associated")

  const messageCantAddService = t("message_service_already_associated")

  const canEdite = !usePermission(Permissions.CanEditeOrders)

  const canEditeCustomer = !usePermission(Permissions.CanEditeClients)

  const cloneOrder = (order: OrderEntity) => {
    return new OrderEntity({ ...order })
  }

  const [isCancel, setIsCancel] = useState(false)

  const { handleEnableRegister, handleDisableRegister, isRegisterEnable } = useRegister()

  const { handleSaveOrder } = useSaveOrder()

  const { handleReloadMealsAndDrinksStock } = useReloadMemory()

  const rodizioApi = useRodizio()

  const { handleGetTableOpenOrders } = useGetTableOpenOrders()

  const { setError } = useError()

  const { setNewConfirmation } = useConfirmation()

  const { userEmployee } = useEmployerLogged()

  const { handleGetPlanUsage } = usePlanUsage()

  const { openPlan } = useUpgradePlan()

  const [isPayment, setPayment] = useState(false)

  const [calculateTotalOrder] = useState<CalculateTotalOrder>(new CalculateTotalOrder())

  const [enableList, setEnableList] = useState(false)

  const [enableCostumer, setCostumer] = useState(false)

  const [isCustomerEditOpen, setIsCustomerEditOpen] = useState(false)

  const [planUsageStatus, setPlanUsageStatus] = useState<PlanUsageStatus>(new PlanUsageStatus({}))

  const [tableSelected, setTable] = useState<Tables | null | undefined>(() => {
    if (order?.tableEntity) {
      return order.tableEntity
    }

    if (!companyMemory.defaultTableId) {
      return null
    }

    return tableMemory.listData.find(
      (table) => table.id === companyMemory.defaultTableId && table.status === EEnableStatusType.Active,
    )
  })

  const [customerSelected, setCostumerSelect] = useState<CustomerEntity | null | undefined>(() => {
    if (order?.customerEntity) {
      return order.customerEntity
    }

    return customerMemory.listData.find((customer) => customer.isDefaultCustomer)
  })

  const [deliveryAddressSelectedId, setDeliveryAddressSelectedId] = useState<number>(order?.addressEntityId ?? 0)

  const [dataListSelected, setListSelect] = useState<ListSelectionsProbs>()

  const [orderPlaceType, setOrderPlaceType] = useState<EOrderPlaceType>(order?.eOrderPlaceType || EOrderPlaceType.Local)

  const [isStorePickup, setIsStorePickup] = useState<boolean>(order?.isStorePickup ?? false)

  const isDefaultCustomerSelected = customerSelected?.isDefaultCustomer === true

  const isDeliveryWithoutRealCustomer =
    orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && isDefaultCustomerSelected

  const customerDeliveryAddresses = customerSelected?.personEntity?.addresses ?? []

  const shouldShowDeliveryAddressArea =
    orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !!customerSelected && !isDefaultCustomerSelected

  const deliveryAddressOptions = [
    { value: "", label: t("label_select_delivery_address_placeholder") },
    ...customerDeliveryAddresses.map((address) => ({
      value: address.id.toString(),
      label: `${address.label} - ${address.street}, ${address.number} - ${address.neighborhood}`,
    })),
  ]

  const [isPrintTargetModalOpen, setIsPrintTargetModalOpen] = useState(false)

  const [isRodizioOpen, setIsRodizioOpen] = useState(false)

  const [isRodizioIncludedVisible, setIsRodizioIncludedVisible] = useState(false)

  const [linkedOrder, setLinkedOrder] = useState<OrderEntity | null>(null)

  const effectiveOrder = linkedOrder ?? order

  const [rodizioManagement, setRodizioManagement] = useState<RodizioManagement | null>(null)

  const [rodizioPlanId, setRodizioPlanId] = useState(0)

  const [isLinkingRodizio, setIsLinkingRodizio] = useState(false)

  const [pendingRodizioSession, setPendingRodizioSession] = useState<RodizioSession | null>(null)

  useEffect(() => {
    const timer = window.setTimeout(() => {
      void (async () => {
        const configuration = await rodizioApi.getOperationConfiguration()
        if (!configuration) return
        setRodizioManagement(configuration)
        setRodizioPlanId((current) => current || configuration.plans.find((plan) => plan.isActive)?.id || 0)
      })()
    }, 0)
    return () => window.clearTimeout(timer)
  }, [])

  const [mealsList, setMealsList] = useState<OrderMeal[]>(
    order ? order.orderMeals.map((e) => new OrderMeal({ ...e })) : [],
  )

  const [drinksList, setDrinksList] = useState<OrderDrink[]>(
    order ? order.orderDrinks.map((e) => new OrderDrink({ ...e })) : [],
  )

  const [orderFinal, setOrderFinal] = useState<OrderEntity>(() => {
    return order ? cloneOrder(order) : new OrderEntity({})
  })

  const visibleMealsList = useMemo(
    () => mealsList.filter((e) => e.chargeType !== EOrderItemChargeType.RodizioIncluded),
    [mealsList],
  )

  const visibleDrinksList = useMemo(
    () => drinksList.filter((e) => e.chargeType !== EOrderItemChargeType.RodizioIncluded),
    [drinksList],
  )

  const rodizioIncludedItems = useMemo(
    () => [
      ...mealsList.filter((e) => e.chargeType === EOrderItemChargeType.RodizioIncluded),
      ...drinksList.filter((e) => e.chargeType === EOrderItemChargeType.RodizioIncluded),
    ],
    [mealsList, drinksList],
  )

  const isTableSelfServiceOrder = order?.isTableSelfServiceOrder() ?? false

  const canStartRodizio = Boolean(
    effectiveOrder &&
    effectiveOrder.eOrderPlaceType === EOrderPlaceType.Local &&
    effectiveOrder.tableId > 0 &&
    effectiveOrder.status === EOrderType.Open &&
    effectiveOrder.orderPaymentEntity.status !== ECustomerPaymentType.WithOutDebit,
  )

  const rodizioActivePlans = rodizioManagement?.plans.filter((plan) => plan.isActive) ?? []

  const canLinkRodizioBeforeSave = Boolean(
    !effectiveOrder &&
    customerSelected &&
    !customerSelected.isDefaultCustomer &&
    orderPlaceType === EOrderPlaceType.Local &&
    tableSelected &&
    rodizioManagement?.settings.isEnabled &&
    rodizioActivePlans.length > 0,
  )

  const orderFlowBadges = useMemo(() => {
    if (!order) {
      return []
    }

    return getOrderFlowStatusBadges(order, companyMemory.orderPaymentTimeoutMinutes)
  }, [order, companyMemory.orderPaymentTimeoutMinutes])

  const [extraServicesList, setExtraServices] = useState<ExtraServiceEntity[]>(() => {
    if (order) {
      return order.extraServices
    }

    const extraService: ExtraServiceEntity[] = []

    extraServiceMemory.listData.forEach((e) => {
      if (e.isAutomatic && e.status === EEnableStatusType.Active) {
        extraService.push(e)
      }
    })

    return extraService
  })

  useEffect(() => {
    if (order) {
      setOrderFinal(order)

      setDeliveryAddressSelectedId(order.addressEntityId ?? 0)

      setIsStorePickup(order.isStorePickup ?? false)
    }
  }, [order, drinksList, mealsList, extraServicesList])

  useEffect(() => {
    if (orderPlaceType !== EOrderPlaceType.Delivery) {
      setDeliveryAddressSelectedId(0)

      setIsStorePickup(false)

      return
    }

    if (isStorePickup) {
      setDeliveryAddressSelectedId(0)

      return
    }

    if (isDefaultCustomerSelected) {
      setDeliveryAddressSelectedId(0)

      return
    }

    const addresses = customerSelected?.personEntity?.addresses ?? []

    if (addresses.length === 0) {
      setDeliveryAddressSelectedId(0)
      return
    }

    const hasSelectedAddress = addresses.some((address) => address.id === deliveryAddressSelectedId)

    if (!hasSelectedAddress) {
      setDeliveryAddressSelectedId(addresses[0].id)
    }
  }, [orderPlaceType, customerSelected, deliveryAddressSelectedId, isStorePickup, isDefaultCustomerSelected])

  useEffect(() => {
    if (companyMemory.subscriptionEntity.eAccountPlansType === EAccountPlansType.Scale) {
      return
    }

    handleGetPlanUsage((usage) => {
      setPlanUsageStatus(usage)

      if (usage.isLimitReached) {
        openPlan(usage)
      }
    })
  }, [])

  const handleCaculate = () => {
    if (!customerSelected) {
      return
    }

    mealsList.forEach((e) => {
      e.calculatePromotions = new CalculatePromotions({
        customer: customerSelected,

        addtionals: e.addtionals,
        selections: e.selections,

        mealsAndDrinks: e.mealEntity.genericFoodEntity,
        timeZoneId: companyMemory.timeZoneId,
        chargeType: e.chargeType,
        catalogValueSnapshot: e.catalogValueSnapshot,
        rodizioIncludesAdditionals: e.rodizioIncludesAdditionals,
      })

      e.calculatePromotions?.calculate()
    })

    drinksList.forEach((e) => {
      e.calculatePromotions = new CalculatePromotions({
        customer: customerSelected,

        addtionals: e.addtionals,
        selections: e.selections,

        mealsAndDrinks: e.drinkEntity.genericFoodEntity,
        timeZoneId: companyMemory.timeZoneId,
        chargeType: e.chargeType,
        catalogValueSnapshot: e.catalogValueSnapshot,
        rodizioIncludesAdditionals: e.rodizioIncludesAdditionals,
      })

      e.calculatePromotions?.calculate()
    })

    setMealsList(mealsList)

    setDrinksList(drinksList)

    var awardManagers: AwardEntity[] = []

    if (order?.id > 0) {
      awardManagers = order.associatedAwards
    } else {
      awardManagers = customerSelected.awardManagers.map((e) => e.awardEntity)
    }

    calculateTotalOrder.calculate(mealsList, drinksList, extraServicesList, awardManagers, order?.couponEntity)
  }

  useMemo(
    () => handleCaculate(),
    [tableSelected, customerSelected, mealsList, drinksList, extraServicesList, order, calculateTotalOrder],
  )

  const getMissingRequiredSelections = (item: GenericOrderFood, allowedSelections: SelectionEntity[]) => {
    return allowedSelections.filter(
      (selection) =>
        selection.status === EEnableStatusType.Active &&
        selection.isRequired &&
        item.selections.filter((current) => current.selectionEntityId === selection.id).length <
          Math.max(1, selection.requiredOptionsCount ?? 1),
    )
  }

  const getMissingRequiredSelectionsMessage = () => {
    const mealMessages = mealsList.flatMap((meal) =>
      getMissingRequiredSelections(meal, meal.mealEntity.genericFoodEntity.allowedSelections ?? []).map(
        (selection) => `${meal.mealEntity.genericFoodEntity.name}: ${selection.name}`,
      ),
    )

    const drinkMessages = drinksList.flatMap((drink) =>
      getMissingRequiredSelections(drink, drink.drinkEntity.genericFoodEntity.allowedSelections ?? []).map(
        (selection) => `${drink.drinkEntity.genericFoodEntity.name}: ${selection.name}`,
      ),
    )

    return [...mealMessages, ...drinkMessages]
  }

  useEffect(() => {
    CreateOrder()
  }, [tableSelected, customerSelected, mealsList, drinksList, extraServicesList, order, calculateTotalOrder])

  const CreateOrder = (): OrderEntity => {
    if (!customerSelected) {
      return orderFinal
    }

    handleCaculate()

    var newOrder = new OrderEntity({
      ...effectiveOrder,

      id: effectiveOrder?.id || -1,

      customerEntity: customerSelected,

      tableEntity: tableSelected || new Tables({}),

      orderPaymentEntity: new OrderPaymentEntity({
        ...effectiveOrder?.orderPaymentEntity,

        id: effectiveOrder?.orderPaymentEntity.id || -1,

        status: effectiveOrder?.orderPaymentEntity.status || ECustomerPaymentType.WithInDebit,

        description: "",

        totalAward: calculateTotalOrder.valueTotalAwards,

        totalMeals: calculateTotalOrder.valueBaseMeals,

        totalDrinks: calculateTotalOrder.valueBaseDrinks,

        totalNotLiquid: calculateTotalOrder.valueBaseSun,

        totalDiscount: calculateTotalOrder.valueTotalDiscount,

        totalBase: calculateTotalOrder.valueBaseSunWithDiscout,

        totalExtra: calculateTotalOrder.valueBaseExtraServices,

        totalFinal: calculateTotalOrder.valuefinal,

        totalAddtionals: calculateTotalOrder.valueAddtionals,
      }),

      associatedAwards: effectiveOrder?.associatedAwards ?? [],

      orderDrinks: drinksList,

      orderMeals: mealsList,

      eOrderPlaceType: orderPlaceType,

      isStorePickup: orderPlaceType === EOrderPlaceType.Delivery ? isStorePickup : false,

      extraServices: extraServicesList,

      addressEntityId:
        orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !isDefaultCustomerSelected
          ? deliveryAddressSelectedId
          : 0,

      addressEntity:
        orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !isDefaultCustomerSelected
          ? (customerSelected.personEntity?.addresses.find((e) => e.id === deliveryAddressSelectedId) ?? null)
          : null,

      isCancel: false,
    })

    setOrderFinal(newOrder)

    return newOrder
  }

  const handleOpenAddMeals = () => {
    const mealsCards = mealsMemory.getListCards(true).filter((e) => e.canUse)

    const comboCards: ListItem[] = comboMemory
      .getListCards(true)
      .filter((e) => e.canUse)
      .map((card) => {
        const combo = comboMemory.findById(card.id)

        if (!combo) {
          return card
        }

        return {
          ...card,
          id: combo.mealId,
          title: `🧩 ${card.title}`,
          dataFilter: [...(card.dataFilter ?? []), "combo"],
        }
      })

    const listCards = [...mealsCards, ...comboCards]
      .filter((card, index, array) => array.findIndex((current) => current.id === card.id) === index)
      .sort((a, b) => a.title.localeCompare(b.title))

    setListSelect({
      title: i18next.t("order:title_meals"),

      icon: faUtensils,

      listCards: listCards,

      onClinck: (e: any) => handleAddMeals(e),

      messageCount: i18next.t("order:message_meals_found"),

      messageEmpty: i18next.t("order:message_meals_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddTables = () => {
    setListSelect({
      title: "Selecione uma mesa",

      icon: faTable,

      listCards: tableMemory.getListCards(true),

      onClinck: (e: any) => {
        setTable(tableMemory.findById(e)!)

        setEnableList(false)
      },

      messageCount: "Mesas encontradas na busca.",

      messageEmpty: i18next.t("order:message_tables_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddDrinks = () => {
    setListSelect({
      title: "Selecione uma bebida",

      icon: faChampagneGlasses,

      listCards: drinksMemory.getListCards(true).filter((e) => e.canUse),

      onClinck: (e: any) => {
        handleAddDrinks(e)
      },

      messageCount: "Bebidas encontradas na busca.",

      messageEmpty: i18next.t("order:message_drinks_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddServices = () => {
    setListSelect({
      title: i18next.t("order:title_extra_services"),

      icon: faBellConcierge,

      listCards: extraServiceMemory.getListCards(false),

      onClinck: (e: any) => {
        const serviceToAdd = extraServiceMemory.findById(e)

        if (!serviceToAdd || serviceToAdd.status !== EEnableStatusType.Active) {
          setEnableList(false)
          return
        }

        if (extraServicesList.find((ss) => ss.id === e) === undefined)
          setExtraServices([...extraServicesList, serviceToAdd])
        else setError(titleCantAddService, messageCantAddService)

        setEnableList(false)
      },

      messageCount: i18next.t("order:message_services_found"),

      messageEmpty: i18next.t("order:message_services_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddCostumer = () => {
    setCostumer(true)
  }

  const handleCloseCustomerEdit = () => {
    const customerId = customerSelected?.id

    if (customerId && customerId > 0) {
      setCostumerSelect(customerMemory.findById(customerId) ?? customerSelected)
    }

    setIsCustomerEditOpen(false)
  }

  const handleSaved = async () => {
    onClonse()

    await onSave()

    void handleReloadMealsAndDrinksStock()
  }

  const refreshOrderAfterRodizio = async () => {
    const current = linkedOrder ?? order
    if (!current?.tableId) return

    await handleGetTableOpenOrders(current.tableId, (orders) => {
      const fresh = orders.find((freshOrder) => freshOrder.id === current.id)
      if (!fresh) return

      setLinkedOrder(fresh)
      setMealsList(fresh.orderMeals.map((e) => new OrderMeal({ ...e })))
      setDrinksList(fresh.orderDrinks.map((e) => new OrderDrink({ ...e })))
      setOrderFinal(cloneOrder(fresh))
      if (fresh.customerEntity) setCostumerSelect(fresh.customerEntity)
    })
  }

  const handleConfirmLinkRodizio = async (planId: number) => {
    setIsLinkingRodizio(true)
    try {
      const draft = CreateOrder()
      const saved = await handleSaveOrder(draft, () => {})
      if (!saved) return

      const created = await rodizioApi.startSession({
        orderId: saved.id,
        planId,
        concurrencyToken: saved.concurrencyToken,
      })
      if (!created) return

      setLinkedOrder(saved)
      setMealsList(saved.orderMeals.map((e) => new OrderMeal({ ...e })))
      setDrinksList(saved.orderDrinks.map((e) => new OrderDrink({ ...e })))
      setOrderFinal(cloneOrder(saved))
      setPendingRodizioSession(created)
      setIsRodizioOpen(true)
    } finally {
      setIsLinkingRodizio(false)
    }
  }

  const handleLinkRodizioClick = () => {
    const plan = rodizioActivePlans.find((current) => current.id === rodizioPlanId)
    if (!plan || !customerSelected) return

    setNewConfirmation(
      i18next.t("rodizio:waiter.confirm_release_title"),
      i18next.t("rodizio:waiter.confirm_release_message", {
        name: customerSelected.personEntity?.name ?? "",
        plan: plan.name,
        price: plan.price.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      }),
      () => {
        void handleConfirmLinkRodizio(plan.id)
      },
    )
  }

  const handleTrySubmit = async () => {
    if (planUsageStatus.isLimitReached) {
      setError(t("title_plan_limit_reached"), t("message_plan_limit_reached"))
      openPlan()
      return
    }

    const missingRequiredSelections = getMissingRequiredSelectionsMessage()

    if (missingRequiredSelections.length > 0) {
      setError(
        t("title_required_selection_missing"),
        t("message_required_selection_missing_summary", { selections: missingRequiredSelections.join(", ") }),
      )
      return
    }

    if (isDeliveryWithoutRealCustomer) {
      setError(t("title_delivery_requires_real_customer"), t("message_delivery_requires_real_customer"))
      return
    }

    if (orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && deliveryAddressSelectedId <= 0) {
      setError(i18next.t("order:title_address_required"), i18next.t("order:message_select_delivery_address"))
      return
    }

    handleSaveOrder(CreateOrder(), handleSaved)
  }

  const handleRemoveMeals = (e: OrderMeal) => {
    setMealsList((prev) => prev.filter((ss) => ss !== e))
  }

  const handleRemoveDrinks = (e: OrderDrink) => {
    setDrinksList((prev) => prev.filter((ss) => ss !== e))
  }

  const handleRemoveServices = (e: ExtraServiceEntity) => {
    setExtraServices((prev) => prev.filter((ss) => ss !== e))
  }

  const handleAddMeals = (e: number) => {
    const mealFromMemory = mealsMemory.findById(e)

    const meal =
      mealFromMemory ??
      (() => {
        const combo = comboMemory.listData.find((comboItem) => comboItem.mealId === e)

        if (!combo) {
          return null
        }

        return new MealEntity({
          id: combo.mealId,
          genericFoodEntity: combo.genericFoodEntity,
        })
      })()

    if (!meal) {
      setError(i18next.t("general:label_invalid"), t("message_meal_unavailable"))
      setEnableList(false)
      return
    }

    const temp: OrderMeal[] = [
      ...mealsList,

      new OrderMeal({
        mealEntity: meal,

        description: "",

        valueBase: meal.genericFoodEntity.valueBase.toString().toNumber(),

        employeeEditeId: userEmployee?.id,

        mealEntityId: meal.id,
      }),
    ]

    setMealsList(temp)

    setEnableList(false)
  }

  const handleAddDrinks = (e: number) => {
    var drink = drinksMemory.findById(e)!

    const temp: OrderDrink[] = [
      ...drinksList,

      new OrderDrink({
        drinkEntity: drink,

        description: "",

        valueBase: drink.genericFoodEntity.valueBase.toString().toNumber(),

        employeeEditeId: userEmployee?.id,

        drinkEntityId: drink.id,
      }),
    ]

    setDrinksList(temp)

    setEnableList(false)
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert}>
            <TitlePageResponsiveIconSmall
              iconColor={THEME.colors.iconBGColor}
              title={title}
              icon={faCommentDollar}
              subtitleChildren={
                <div className={`w-[420px] md:w-[500px] ${defaultStyle.ButtonsActions}`}>
                  <GenericDropDown
                    data={Object.mapEnumToStrings(EOrderPlaceType)}
                    initialState={orderPlaceType}
                    handlerFuncion={(e) => setOrderPlaceType(e.currentTarget.selectedIndex as EOrderPlaceType)}
                    disable={canEdite}
                    descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.select.select"
                  />

                  {order && order.id > 0 && (
                    <>
                      <GetSpace left={5} />

                      <ButtonIcon
                        typeButton="button"
                        sizeNumber={SIZE.buttonCloseIconSize}
                        bgColor={THEME.colors.buttonBGSaveColor}
                        iconColor={THEME.colors.buttonFGSaveColor}
                        icon={faPrint}
                        onClick={() => setIsPrintTargetModalOpen(true)}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setIsPrintTargetModalOpenTrue"
                      />
                    </>
                  )}

                  <GetSpace left={5} />

                  <ButtonIcon
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGCloseColor}
                    iconColor={THEME.colors.buttonFGCloseColor}
                    icon={faClose}
                    onClick={onClonse}
                    size="small"
                    descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.onClonse"
                  />
                </div>
              }
            />

            <GetSpace top={5} />

            {isDeliveryWithoutRealCustomer && (
              <>
                <div className="rounded-xl border-2 border-red-500 bg-red-50 px-4 py-3 text-red-800 shadow-sm">
                  <div className="flex items-start gap-3">
                    <AlertTriangle size={22} className="mt-0.5 shrink-0 text-red-700" />

                    <div className="flex flex-col gap-1">
                      <strong className="text-sm font-extrabold uppercase tracking-wide">
                        {t("title_delivery_requires_real_customer")}
                      </strong>

                      <span className="text-sm font-semibold leading-snug">
                        {t("message_delivery_requires_real_customer")}
                      </span>
                    </div>
                  </div>
                </div>

                <GetSpace top={5} />
              </>
            )}

            {order?.orderPaymentEntity.isOnlinePayment &&
              renderProviderChargeReference(
                order.orderPaymentEntity.externalReference,
                t("label_provider_external_reference"),
              )}

            <PlanUsageAlert planUsageStatus={planUsageStatus} />

            {!planUsageStatus.isLimitReached && (
              <>
                <GetSpace top={15} />

                <form onSubmit={handleTrySubmit}>
                  {isTableSelfServiceOrder && (
                    <>
                      <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
                        <div className="rounded-xl border-2 border-violet-300 bg-violet-50 p-2 text-violet-800">
                          <p className="text-xs font-black uppercase tracking-wider">
                            {t("label_table_self_service_order")}
                          </p>

                          <p className="mt-2 text-sm font-bold">{order?.getCustomerDisplayName()}</p>

                          <p className="mt-1 text-xs font-semibold">
                            {t("label_cpf")}: {order?.getCustomerDisplayCpf()}
                          </p>
                        </div>
                      </Animate>

                      <GetSpace top={10} />
                    </>
                  )}

                  {orderFlowBadges.length > 0 && (
                    <>
                      <Animate type={AnimationTypes.fadeIn} duration="1.5s">
                        <div className="flex flex-wrap items-center gap-2 px-1">
                          <span className="text-[11px] font-semibold text-gray-500">
                            {i18next.t("order:status_flow_title")}
                          </span>

                          {orderFlowBadges.map((badge) => (
                            <span
                              key={`${order?.id}-${badge.label}`}
                              className={`px-2 py-1 text-[11px] font-semibold rounded-full ${badge.className}`}
                            >
                              {badge.label}
                            </span>
                          ))}
                        </div>
                      </Animate>

                      <GetSpace top={5} />
                    </>
                  )}

                  {customerSelected ? (
                    <TitlePageResponsiveIconSmall
                      iconColor={THEME.colors.iconBGSecondaryColor}
                      boxShadow="none"
                      title={
                        isTableSelfServiceOrder ? order?.getCustomerDisplayName() : customerSelected.personEntity.name
                      }
                      icon={faUser}
                      subtitleChildren={
                        <>
                          {isTableSelfServiceOrder && (
                            <BasicCard title={order?.getCustomerDisplayCpf() ?? ""} borderColor={THEME.colors.white} />
                          )}

                          {!isTableSelfServiceOrder && !customerSelected.isDefaultCustomer && (
                            <BasicCard title={customerSelected.personEntity.cpf} borderColor={THEME.colors.white} />
                          )}

                          {!isTableSelfServiceOrder && customerSelected.isDefaultCustomer && (
                            <div className=" flex items-center gap-2 rounded-lg border-2 border-amber-400 bg-amber-50 px-3 py-2 text-red-600">
                              <AlertTriangle size={16} className="shrink-0 text-red-800" />

                              <span className="flex-1 text-xs font-bold text-center uppercase tracking-wide whitespace-nowrap overflow-hidden text-ellipsis">
                                {t("label_default_customer")}
                              </span>
                            </div>
                          )}

                          {!isTableSelfServiceOrder && !customerSelected.isDefaultCustomer && (
                            <>
                              <GetSpace left={5} />

                              <ButtonIcon
                                animationTypes={AnimationTypes.fadeIn}
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGSaveColor}
                                iconColor={THEME.colors.buttonFGSaveColor}
                                icon={faPenToSquare}
                                disabled={canEditeCustomer}
                                onClick={() => setIsCustomerEditOpen(true)}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setIsCustomerEditOpenTrue"
                              />
                            </>
                          )}

                          {(!order || order?.id < 1) && (
                            <>
                              <GetSpace left={5} />

                              <ButtonIcon
                                animationTypes={AnimationTypes.fadeIn}
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                iconColor={THEME.colors.buttonFGRemoveColor}
                                icon={faTrash}
                                disabled={canEdite}
                                onClick={() => {
                                  setCostumerSelect(null)
                                  handleOpenAddCostumer()
                                }}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.faTrash"
                              />
                            </>
                          )}
                        </>
                      }
                    />
                  ) : (
                    <TitlePageResponsiveIconSmall
                      iconColor={THEME.colors.iconBGColor}
                      subtitle={t("label_select_customer")}
                      icon={faUserAlt}
                      boxShadow="none"
                      children={
                        <ButtonIcon
                          sizeNumber={SIZE.buttonExpandIcon}
                          bgColor={THEME.colors.buttonBGPlusColor}
                          iconColor={THEME.colors.buttonFGPlusColor}
                          icon={faPlus}
                          disabled={canEdite}
                          onClick={handleOpenAddCostumer}
                          size="small"
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddCostumer"
                        />
                      }
                    />
                  )}

                  {shouldShowDeliveryAddressArea && (
                    <>
                      <GetSpace top={5} />

                      {customerDeliveryAddresses.length > 0 ? (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGColor}
                          title={i18next.t("order:title_delivery_address")}
                          icon={faLocationDot}
                          boxShadow="none"
                          children={
                            <GenericDropDown
                              data={deliveryAddressOptions}
                              initialState={deliveryAddressSelectedId > 0 ? deliveryAddressSelectedId.toString() : ""}
                              disable={canEdite}
                              handlerFuncion={(event) =>
                                setDeliveryAddressSelectedId(Number(event.currentTarget.value || 0))
                              }
                              descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.select.select2"
                            />
                          }
                        />
                      ) : (
                        <div className="rounded-xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-amber-900 shadow-sm">
                          <div className="flex items-start gap-3">
                            <AlertTriangle size={20} className="mt-0.5 shrink-0 text-amber-700" />

                            <div className="flex flex-col gap-1">
                              <strong className="text-sm font-extrabold uppercase tracking-wide">
                                {t("title_customer_without_delivery_address")}
                              </strong>

                              <span className="text-sm font-semibold leading-snug">
                                {t("message_customer_without_delivery_address")}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {orderPlaceType === EOrderPlaceType.Local && (
                    <>
                      <GetSpace top={5} />

                      {tableSelected ? (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGSecondaryColor}
                          boxShadow="none"
                          title={i18next.t("components:label_tables")}
                          icon={faTable}
                          subtitleChildren={
                            <>
                              <BasicCard title={tableSelected.number.toString()} borderColor={THEME.colors.white} />

                              <GetSpace left={5} />

                              <ButtonIcon
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                iconColor={THEME.colors.buttonFGRemoveColor}
                                icon={faTrash}
                                disabled={canEdite}
                                onClick={() => setTable(null)}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setTableNull"
                              />
                            </>
                          }
                        />
                      ) : (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGColor}
                          subtitle={"Selecionar Mesa"}
                          boxShadow="none"
                          icon={faTable}
                          children={
                            <ButtonIcon
                              sizeNumber={SIZE.buttonExpandIcon}
                              bgColor={THEME.colors.buttonBGPlusColor}
                              iconColor={THEME.colors.buttonFGPlusColor}
                              icon={faPlus}
                              disabled={canEdite}
                              onClick={handleOpenAddTables}
                              size="small"
                              descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddTables"
                            />
                          }
                        />
                      )}
                    </>
                  )}

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    title={i18next.t("order:title_meals")}
                    iconColor={THEME.colors.iconBGColor}
                    icon={faUtensils}
                    boxShadow="none"
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        typeButton="button"
                        disabled={canEdite}
                        onClick={handleOpenAddMeals}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddMeals"
                      />
                    }
                    children={
                      <>
                        <GetSpace top={5} />

                        {visibleMealsList.length > 0 && (
                          <>
                            <CountElements
                              count={visibleMealsList.length}
                              title={i18next.t("order:title_meals_dots")}
                              boxShadow={"none"}
                            />

                            <GetSpace top={5} />

                            {visibleMealsList.map((e, index) => {
                              return (
                                <React.Fragment key={index * 3000}>
                                  <GetSpace top={5} />

                                  <ElementOrder
                                    addtionalsItems={addtionalMemory

                                      .getListCards(false)

                                      .filter((card) =>
                                        e.mealEntity.genericFoodEntity.allowedAddtionals
                                          .map((e) => e.id)
                                          .includes(card.id),
                                      )}
                                    allowedAddtionals={e.mealEntity.genericFoodEntity.allowedAddtionals}
                                    selectionsItems={(e.mealEntity.genericFoodEntity.allowedSelections ?? []).filter(
                                      (selection) => selection.status === EEnableStatusType.Active,
                                    )}
                                    urlImage={e.mealEntity.genericFoodEntity.iconUrl.toClientRequest()}
                                    employeeStringId={e.employeeEditeId}
                                    calculatePromotions={e.calculatePromotions}
                                    date={e.date}
                                    isClosed={e.currentStatus === EOrderCurrentStatus.Closed}
                                    disable={canEdite}
                                    key={index}
                                    icon={faBolt}
                                    genericOrderMeal={e}
                                    onEditeAddtional={CreateOrder}
                                    onRemove={() => {
                                      setNewConfirmation(titleRemove, messageRemove, () => handleRemoveMeals(e))
                                    }}
                                    title={e.mealEntity.genericFoodEntity.name}
                                  />
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    iconColor={THEME.colors.iconBGColor}
                    title={"Bebidas"}
                    boxShadow="none"
                    icon={faChampagneGlasses}
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        disabled={canEdite}
                        onClick={handleOpenAddDrinks}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddDrinks"
                      />
                    }
                    children={
                      <>
                        <GetSpace top={5} />

                        {visibleDrinksList.length > 0 && (
                          <>
                            <CountElements count={visibleDrinksList.length} title={"Bebidas..."} boxShadow={"none"} />

                            <GetSpace top={5} />

                            {visibleDrinksList.map((e, index) => {
                              return (
                                <React.Fragment key={e.id ?? index}>
                                  <GetSpace top={5} />

                                  <ElementOrder
                                    addtionalsItems={addtionalMemory

                                      .getListCards(false)

                                      .filter((card) =>
                                        e.drinkEntity.genericFoodEntity.allowedAddtionals

                                          .map((e) => e.id)

                                          .includes(card.id),
                                      )}
                                    allowedAddtionals={e.drinkEntity.genericFoodEntity.allowedAddtionals}
                                    selectionsItems={(e.drinkEntity.genericFoodEntity.allowedSelections ?? []).filter(
                                      (selection) => selection.status === EEnableStatusType.Active,
                                    )}
                                    urlImage={e.drinkEntity.genericFoodEntity.iconUrl.toClientRequest()}
                                    employeeStringId={e.employeeEditeId}
                                    title={e.drinkEntity.genericFoodEntity.name}
                                    calculatePromotions={e.calculatePromotions}
                                    isClosed={e.currentStatus === EOrderCurrentStatus.Closed}
                                    date={e.date}
                                    key={index}
                                    disable={canEdite}
                                    icon={faBolt}
                                    genericOrderMeal={e}
                                    onEditeAddtional={CreateOrder}
                                    onRemove={() => {
                                      setNewConfirmation(titleRemove, messageRemove, () => handleRemoveDrinks(e))
                                    }}
                                  />
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  {rodizioIncludedItems.length > 0 && (
                    <>
                      <div className={defaultStyle.divisionBar}></div>

                      <div className="rounded-lg border border-orange-100 bg-orange-50/40 p-2">
                        <button
                          type="button"
                          onClick={() => setIsRodizioIncludedVisible((current) => !current)}
                          className="flex w-full items-center justify-between gap-2 p-1 text-left font-bold text-orange-800"
                          data-interaction-description-key="interactionDescriptions:pages.fluxo.order.orderPupop.button.toggleRodizioIncludedItems"
                        >
                          <span>
                            {i18next.t("rodizio:waiter.included_items_toggle", {
                              count: rodizioIncludedItems.length,
                            })}
                          </span>
                          <FontAwesomeIcon icon={isRodizioIncludedVisible ? faCaretDown : faCaretRight} />
                        </button>

                        {isRodizioIncludedVisible && (
                          <ul className="mt-2 space-y-1 text-sm text-orange-900">
                            {rodizioIncludedItems.map((item, index) => (
                              <li
                                key={item.id ?? index}
                                className="flex items-center justify-between gap-2 rounded bg-white px-2 py-1"
                              >
                                <span>{item.getName()}</span>
                                {item.rodizioParticipantName && (
                                  <span className="text-xs font-semibold text-orange-600">
                                    {item.rodizioParticipantName}
                                  </span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </>
                  )}

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    iconColor={THEME.colors.iconBGColor}
                    title={i18next.t("order:title_extra_services_lower")}
                    icon={faBellConcierge}
                    boxShadow="none"
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        typeButton="button"
                        disabled={canEdite}
                        onClick={handleOpenAddServices}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddServices"
                      />
                    }
                    children={
                      <>
                        {extraServicesList.length > 0 && (
                          <>
                            <CountElements
                              count={extraServicesList.length}
                              title={i18next.t("order:title_extra_services_dots")}
                              boxShadow={"none"}
                            />

                            {extraServicesList.map((e, index) => {
                              return (
                                <div
                                  className="rounded-lg mt-1 border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40 p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
                                  key={e.id ?? index}
                                >
                                  <GetSpace top={5} />

                                  <TitlePageResponsiveIconSmall
                                    title={e.name}
                                    icon={faCaretRight}
                                    sizeProp="sm"
                                    boxShadow="none"
                                    subtitleChildren={
                                      <>
                                        <BasicCard
                                          borderColor={THEME.colors.white}
                                          txtColor={THEME.colors.iconBGAlertColor}
                                          title={
                                            e.conditionType === EMoneyConditionType.Percentage
                                              ? `${e.valueBase}%`
                                              : convertToLocalMoney(e.valueBase)
                                          }
                                        />

                                        <GetSpace left={5} />

                                        <ButtonIcon
                                          sizeNumber={SIZE.buttonExpandIcon}
                                          bgColor={THEME.colors.buttonBGCloseColor}
                                          icon={faMinus}
                                          disabled={canEdite}
                                          typeButton="button"
                                          onClick={() =>
                                            setNewConfirmation(titleRemove, messageRemove, () =>
                                              handleRemoveServices(e),
                                            )
                                          }
                                          size="small"
                                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setNewConfirmationTitleRemoveMessageRemoveHandleRemoveServic"
                                        />
                                      </>
                                    }
                                  />
                                </div>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  <CalculateView
                    valueBaseMeals={calculateTotalOrder.valueBaseMeals}
                    valueBaseDrinks={calculateTotalOrder.valueBaseDrinks}
                    valueAddtionals={calculateTotalOrder.valueAddtionals}
                    valueBaseSum={calculateTotalOrder.valueBaseSun}
                    valueTotalShippingFee={order?.orderPaymentEntity.shippingFee ?? 0}
                    valueTotalDiscount={calculateTotalOrder.valueTotalDiscount}
                    valueBaseSumWithDiscount={calculateTotalOrder.valueBaseSunWithDiscout}
                    valueBaseExtraServices={calculateTotalOrder.valueBaseExtraServices}
                    valueTotalAwards={calculateTotalOrder.valueTotalAwards}
                    valueFinalWithoutAwards={calculateTotalOrder.valuefinalWithoutAwards}
                    valueTotalCoupons={calculateTotalOrder.valueTotalCupons}
                    valueFinal={calculateTotalOrder.valuefinal + (order?.orderPaymentEntity.shippingFee ?? 0)}
                    awards={order?.associatedAwards}
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  {!tableSelected && orderPlaceType === EOrderPlaceType.Local && (
                    <span className="flex text-sm justify-center text-red-600 font-bold">
                      Por favor selecione uma mesa para salvar
                    </span>
                  )}

                  <div className={defaultStyle.divisionBar}></div>

                  {canLinkRodizioBeforeSave && (
                    <div className="rounded-lg border-2 border-orange-200 bg-orange-50/40 p-3">
                      <p className="text-xs font-black uppercase tracking-wide text-orange-700">
                        {i18next.t("rodizio:waiter.release_title")}
                      </p>
                      {rodizioActivePlans.length > 1 && (
                        <div className="mt-2">
                          <GenericDropDown
                            legend={i18next.t("rodizio:waiter.plan")}
                            data={rodizioActivePlans.map((plan) => ({
                              label: `${plan.name} — ${plan.price.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`,
                              value: String(plan.id),
                            }))}
                            initialState={String(rodizioPlanId)}
                            handlerFuncion={(event) => setRodizioPlanId(Number(event.target.value))}
                            descriptionKey="interactionDescriptions:rodizio.waiter.plan"
                          />
                        </div>
                      )}
                      <div className="mt-2">
                        <Button
                          label={
                            isLinkingRodizio ? i18next.t("rodizio:common.saving") : i18next.t("rodizio:waiter.release")
                          }
                          typeButton="button"
                          type="primary"
                          size="medium"
                          disabled={isLinkingRodizio || rodizioPlanId <= 0}
                          onClick={handleLinkRodizioClick}
                          bgColor={THEME.colors.buttonBGSaveColor}
                          descriptionKey="interactionDescriptions:rodizio.waiter.release"
                        />
                      </div>
                    </div>
                  )}

                  <div className={defaultStyle.divisionBar}></div>

                  <div className={defaultStyle.buttonsController}>
                    <CanView permission={Permissions.CanEditeOrders}>
                      {((orderPlaceType === EOrderPlaceType.Local && tableSelected) ||
                        (orderPlaceType === EOrderPlaceType.Delivery &&
                          !isDeliveryWithoutRealCustomer &&
                          customerSelected &&
                          (isStorePickup || deliveryAddressSelectedId > 0) &&
                          !order?.orderPaymentEntity.isOnlinePayment &&
                          order?.eOrderStatusType !== EOrderStatusType.Delivered)) && (
                        <Button
                          label={t("buttons:button_save")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          onClick={() => handleTrySubmit()}
                          bgColor={THEME.colors.buttonBGSaveColor}
                          disabled={planUsageStatus.isLimitReached}
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.save"
                        />
                      )}

                      {canStartRodizio && (
                        <Button
                          label={t("rodizio:waiter.open_action")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          onClick={() => setIsRodizioOpen(true)}
                          bgColor={THEME.colors.buttonBGSaveColor}
                          descriptionKey="interactionDescriptions:rodizio.waiter.open"
                        />
                      )}
                    </CanView>

                    {order && (
                      <>
                        <CanView permission={Permissions.CanEditeOrders}>
                          {(order.eOrderPlaceType !== EOrderPlaceType.Delivery ||
                            order.addressEntityId === deliveryAddressSelectedId) && (
                            <>
                              <GetSpace left={5} />

                              <Button
                                label={t("buttons:button_pay")}
                                typeButton="button"
                                type="primary"
                                size="medium"
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                onClick={() => setPayment(true)}
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.pay"
                              />
                            </>
                          )}

                          <GetSpace left={5} />

                          <Button
                            label={t("buttons:button_cancel")}
                            typeButton="button"
                            type="primary"
                            size="medium"
                            bgColor={THEME.colors.buttonBGCloseColor}
                            onClick={() => setIsCancel(true)}
                            descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.cancel"
                          />
                        </CanView>

                        <GetSpace right={5} />

                        <Button
                          label={t("buttons:button_register")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          bgColor={THEME.colors.buttonBGRegisterColor}
                          onClick={handleEnableRegister}
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.register"
                        />
                      </>
                    )}
                  </div>
                </form>
              </>
            )}
          </div>
        </Animate>

        {isRegisterEnable && order && (
          <ViewRegister id={order.id} typeEntity="OrderEntityId" onClose={handleDisableRegister} />
        )}

        {enableList && (
          <ListSelections
            title={dataListSelected!.title}
            icon={dataListSelected!.icon}
            listCards={dataListSelected!.listCards}
            messageCount={dataListSelected!.messageCount}
            messageEmpty={dataListSelected!.messageEmpty}
            onClinck={dataListSelected!.onClinck}
            onClonse={dataListSelected!.onClonse}
          />
        )}

        {enableCostumer && (
          <CostumerList
            onClinck={(e) => {
              setCostumerSelect(customerMemory.findById(e))

              setCostumer(false)
            }}
            listCards={customerMemory.getListCards(true)}
            onClonse={() => setCostumer(false)}
          />
        )}

        {isCustomerEditOpen && customerSelected && !customerSelected.isDefaultCustomer && (
          <CustomerPopup
            title={i18next.t("customer:title_customer_edite")}
            costumer={customerSelected}
            onClonse={handleCloseCustomerEdit}
          />
        )}

        {isCancel && (
          <CancelOrderPupop icon={faWarning} order={order} onSave={handleSaved} onClonse={() => setIsCancel(false)} />
        )}

        {isPayment && (
          <DetailsPaymentPupop order={orderFinal} onSave={handleSaved} onClonse={() => setPayment(false)} />
        )}
      </div>

      {order && (
        <OrderPrintOptionsPupop
          isOpen={isPrintTargetModalOpen}
          title={t("title_print_target")}
          orderId={order.id}
          printScope="customer"
          onClose={() => setIsPrintTargetModalOpen(false)}
        />
      )}

      {isRodizioOpen && effectiveOrder && (
        <RodizioOrderPopup
          order={effectiveOrder}
          initialSession={pendingRodizioSession ?? undefined}
          onClose={() => {
            setIsRodizioOpen(false)
            setPendingRodizioSession(null)
            void refreshOrderAfterRodizio()
          }}
        />
      )}
    </ModalPortal>
  )
}
